import { render, staticRenderFns } from "./RewardItem.vue?vue&type=template&id=07f1ce39&scoped=true&"
import script from "./RewardItem.vue?vue&type=script&lang=js&"
export * from "./RewardItem.vue?vue&type=script&lang=js&"
import style0 from "./RewardItem.vue?vue&type=style&index=0&id=07f1ce39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f1ce39",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCardTitle,VTooltip})
